/**
 * @generated SignedSource<<b94c891f8f80b6fccbd49b2589a4fa99>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddOrEditSignUp_event$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ActionButtonsEventSignUp_event" | "FormStepManager_event" | "useInitializeEventSignUpProcess_event">;
  readonly " $fragmentType": "AddOrEditSignUp_event";
};
export type AddOrEditSignUp_event$key = {
  readonly " $data"?: AddOrEditSignUp_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddOrEditSignUp_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddOrEditSignUp_event",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useInitializeEventSignUpProcess_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FormStepManager_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ActionButtonsEventSignUp_event"
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "83eb9dbe881710d5e83f5bc73335486a";

export default node;
